import { defineStore } from "pinia";
import { ref } from "vue";
/**
 * Shared collapse state for the global navigation rail (MainSidebar).
 * Owned by the sidebar module; consumed cross-module (e.g. the campaign
 * assistant collapses the rail on entry). Preference is NOT persisted
 * (US-3.20: resets on next assistant entry).
 */
export const useGlobalSideMenu = defineStore("globalSideMenu", () => {
    const collapsed = ref(false);
    function setCollapsed(value) {
        collapsed.value = value;
    }
    function collapseOnEnter() {
        collapsed.value = true;
    }
    return { collapsed, setCollapsed, collapseOnEnter };
});
